import { IAppState } from '@core/store/types';

export const selectCurrentUser = (state: IAppState) => state.account.user;
export const selectToken = (state: IAppState) => state.account.token;
export const selectUserId = (state: IAppState) => state?.account?.user?.id;
export const selectRoleId = (state: IAppState) => state?.account?.user?.roleId;
